import type { VideoPlatform } from '@/lib/video-metadata';
import { parseFrameioUrl } from './links';
import { parseMediasiloUrl } from '@/lib/mediasilo/links';

/** Description key for the "unsupported source" toast. Legacy or non-share
 *  Frame.io links (f.io/…, app.frame.io/…) get the Frame.io-specific hint
 *  explaining which link format works (same for non-review MediaSilo links);
 *  everything else keeps the generic copy. */
export function unsupportedSourceDescriptionKey({
  url,
  platform,
}: {
  url: string;
  platform: VideoPlatform;
}): string {
  if (platform === 'unknown' && parseFrameioUrl(url).kind === 'unsupported') {
    return 'frameio.errors.unsupportedLink';
  }
  if (platform === 'unknown' && parseMediasiloUrl(url).kind === 'unsupported') {
    return 'mediasilo.errors.unsupportedLink';
  }
  return 'library.unsupportedSourceDescription';
}
